import React from "react";

function FeedbackTab({ data = {}, onChange }) {
  const handleInput = (e) => {
    const { name, value } = e.target;
    onChange({ ...data, [name]: value });
  };

  return (
    <div className="bg-white p-3 rounded-md shadow-md border">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        
        {/* Rating */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Rating</label>
          <input
            type="number"
            name="rating"
            min={1}
            max={5}
            value={data.rating || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Rating (1-5)"
          />
        </div>

        {/* Comments */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Comments</label>
          <textarea
            name="comments"
            value={data.comments || ""}
            onChange={handleInput}
            rows={1}
            className="border rounded px-2 py-1 resize-none"
            placeholder="Your feedback..."
          />
        </div>
      </div>
    </div>
  );
}

export default FeedbackTab;
